import { useMemo } from 'react';
import { Scale } from '../../../../Base/Interfaces/Scale.interface';
import { TOOTH_IMAGE_BASE } from '../../../Helpers/periodontalLines/toothImageBase';

export default function useRenderSize(scale: Scale) {
	const renderSize = useMemo(() => {
		const renderHeight = TOOTH_IMAGE_BASE.h / scale.vertical;
		const renderWidth = TOOTH_IMAGE_BASE.w / scale.horizontal;
		return {
			w: renderWidth,
			h: Math.min(renderHeight, TOOTH_IMAGE_BASE.h),
		};
	}, [scale]);

	return { base: TOOTH_IMAGE_BASE, renderSize };
}
